"use client";

/**
 * THE locked-card call-to-action - one component so every Pro teaser
 * (seller history, negotiation, photo intel, and whatever comes next)
 * renders the exact same button: full-width, plain indigo, chevron,
 * label carrying the viewer's state:
 *   - preview ended        -> the win-back ("Geri qaytar")
 *   - anon / trial-eligible -> the free-trial framing
 *   - trial used            -> the plain upgrade
 */
import { ChevronRight } from "lucide-react";
import LocalizedLink from "@/lib/localized-link";
import { useT } from "@/lib/locale-context";
import { useAuth } from "@/lib/auth-context";

export default function ProCta({ previewEnded }: { previewEnded?: boolean }) {
  const t = useT();
  const { user } = useAuth();
  const label = previewEnded
    ? t("pricing.trial_ended.cta")
    : !user || user.pro_trial_eligible === true
      ? t("map.personal.trial_cta")
      : t("result.market.pro_cta");
  return (
    <LocalizedLink
      href="/pricing"
      className="flex w-full items-center justify-center gap-1.5 rounded-xl bg-indigo-600 px-4 py-2.5 text-xs font-bold text-white shadow-sm hover:bg-indigo-700 transition-colors"
    >
      {label}
      <ChevronRight className="w-3.5 h-3.5" />
    </LocalizedLink>
  );
}
